/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Ideas_AnswerInputs */

const en_landing_faq_ideas_answer = /** @type {(inputs: Landing_Faq_Ideas_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. It retrieves and delivers your analysts' original research exactly as published - no enrichment, no reinterpretation.`)
};

/**
* | output |
* | --- |
* | "No. It retrieves and delivers your analysts' original research exactly as published - no enrichment, no reinterpretation." |
*
* @param {Landing_Faq_Ideas_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_ideas_answer = /** @type {((inputs?: Landing_Faq_Ideas_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Ideas_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_ideas_answer(inputs)
});